import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

export enum CreditGTMEvent {
    BANNER = "banner"
}
export enum CreditTrackingActionType {
    VIEW = "view",
    CLICK = "click"
}
export const creditEventCategory = "zobacz oferty";
export const creditEventLabel = "kalkulator-kredytu-hipotecznego";

export const creditOfferLeadTracking = (eventType: CreditTrackingActionType) => {
    hitGoogleTagManager({event: CreditGTMEvent.BANNER, data: {event_action: eventType, event_category: creditEventCategory, event_label: creditEventLabel}});
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

export enum CreditGTMEvent {
    BANNER = "banner"
}
export enum CreditTrackingActionType {
    VIEW = "view",
    CLICK = "click"
}
export const creditEventCategory = "zobacz oferty";
export const creditEventLabel = "kalkulator-kredytu-hipotecznego";

export const creditOfferLeadTracking = (eventType: CreditTrackingActionType) => {
    hitGoogleTagManager({event: CreditGTMEvent.BANNER, data: {event_action: eventType, event_category: creditEventCategory, event_label: creditEventLabel}});
};
